import React, { useCallback, useState, useEffect } from 'react';
import Button from "@material-ui/core/Button";
import useTranslation from "../translation";
import { useAppState } from "../AppState";
import { getDefaultValue2 } from "./form";

const acceptableFileFormats = ".pdf, .jpg, .jpeg, .png, .img, .bmp, .tif, .tiff|image/*";

export function InputFiles({ fieldName, errors, register, formType }) {
    const [{ formValues, claimDate }, dispatch] = useAppState();
    const { onChange, ref } = register(fieldName);
    const [fileList, setFileList] = useState();
    const translation = useTranslation();
    const [error, setError] = useState(""); 


    useEffect(() => {
        var defaultValues = getDefaultValue2(formValues, formType, fieldName)
        setFileList(defaultValues);
    }, []);

    const onFileChange = useCallback((event) => {
        const files = event.target.files;

        if (files.length === 0) {
            // No file is selected, so do nothing
            setError("");
            return; 
        }


        const validExtensions = ['pdf', 'jpg', 'jpeg', 'png', 'img', 'bmp', 'tif', 'tiff'];
        let isValidFormat = true;

        for (let i = 0; i < files.length; i++) {
            const fileExtension = files[i].name.split('.').pop().toLowerCase();
            if (!validExtensions.includes(fileExtension)) {
                isValidFormat = false;
                break;
            }
        }

        if (isValidFormat) {
            setFileList(files);
            onChange(event);
            setError(""); 
        } else {
            setError(translation.error_invalidfileformat); 
        }
    }, [onChange, translation.error_invalidfileformat]);

    return (
        <>
          
            <Button variant="contained" component="label">
                {translation.file_button}
                <input
                    type="file"
                    id={fieldName}
                    name={fieldName}
                    multiple
                    accept={acceptableFileFormats}
                    ref={ref}
                    hidden
                    onChange={onFileChange}
                    //{/*aria-describedby="fileAttachmentsDescription"*/}
                />
                <p>{errors[fieldName]?.message}</p>
            </Button>
            {error && <p style={{ color: 'red' }}>{error}</p>} 
            <br />
          
            <ul>
            {fileList &&
                Array.from(fileList).map(file => {
                    return (
                        <li key={file.name}>{file.name}</li>
                    );
                })}
            </ul>
        </>
    );
}